<template>
  <v-layout v-if="vmode === 'mobile'" :class="['mrow pa-2 border-b--thin', {'selected': selected[item.id]}]">
    <v-btn
    icon
    text
    @click.stop="$emit('checkRow', item)">
      <v-icon :color="selected[item.id] ? 'color1' : ''"> 
        {{ selected[item.id] ? 'check_box' : 'check_box_outline_blank' }}
      </v-icon>
    </v-btn>

    <v-layout column class="mt-3">
      <div v-html="highlightedID" class="text-truncate">
      </div>

      <div>
        <v-icon small :color="item.item_count !== 0 ? 'color1' : 'grey'">mdi-comment-eye-outline</v-icon>
        <span :class="['caption', item.item_count !== 0 ? 'color1--text' : 'grey--text']">
          {{ item.item_count }} items
        </span>
      </div>
    </v-layout>

    <!-- RIGHT SIDE -->
    <div class="text-right mt-3">
      <div :class="['caption text-ellipsed']">
      {{ dateFromNow }}
      </div>
      <div class="textSecondary--text caption">
        {{ humanDate }}
      </div>
    </div>
  </v-layout>



  <tr v-else-if="vmode === 'table'"
  :class="{'selected': selected[item.id]}">
    <td class="sticky">
      <v-layout align-center>
        <v-btn
        icon
        text
        @click.stop="$emit('checkRow', item)">
          <v-icon :color="selected[item.id] ? 'color1' : ''"> 
            {{ selected[item.id] ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </v-btn>
        <transition
        name="slide-x-transition"
        appear
        hide-on-leave
        mode="out-in">
          <v-icon v-if="itemsMeta.newID === item.id" color="color1" style="position: absolute; left: 0px; top: 0px;">mdi-new-box</v-icon>
        </transition>

        <img class="c-align-self-start" src="@/assets/img/illustrations/package.png" alt="cardboard box" width="45px">

        <v-layout column>
          <div v-html="highlightedID" class="text-truncate">
          </div>
        </v-layout>
      </v-layout>
    </td>
    <td>
      <v-chip outlined>
        <v-icon small :color="item.item_count !== 0 ? 'color1' : 'grey'">mdi-comment-eye-outline</v-icon>
        <span :class="['caption', item.item_count !== 0 ? 'color1--text' : 'grey--text']">
          {{ item.item_count }}
        </span>
      </v-chip>
    </td>
    <td>
      <div :class="['text-ellipsed']">
      {{ dateFromNow }}
      </div>
      <div class="textSecondary--text caption">
        {{ humanDate }}
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  props: ['vmode', 'item', 'itemsMeta', 'selected', 'searchFilters'],
  computed: {
    highlightedID () {
      var replacedStr = (this.searchFilters.id || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      replacedStr = this.item.id.toString().replace(new RegExp(replacedStr, 'gi'), '<span class="font-weight-regular color1--text">$&</span>')
      if (!this.searchFilters.id) {
        return replacedStr
      }
      return '<span class="font-weight-regular">' + replacedStr + '</span>'
    },
    humanDate () {
      if (this.$moment.utc(this.item.date).isValid()) {
        if (this.vmode === 0) {
          return this.$moment(this.item.date).format('ddd D, MMM YYYY, h:mm')
        } else {
          return this.$moment(this.item.date).format('DD MMM YYYY, ddd')
        }
      }
      return ''
    },
    dateFromNow () {
      if (this.$moment.utc(this.item.date).isValid()) {
        return this.$moment.utc(this.item.date).fromNow()
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.mrow {
  cursor: pointer;
  &:hover {
    background: var(--v-backgroundHover-base);
  }
  &.selected {
    background: var(--v-backgroundHover-base)!important;
  }
}
</style>